
class MultiSamplesContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHashes",
				"type": "bytes32[16]"
			},
			{
				"name": "titles",
				"type": "bytes32[16]"
			},
			{
				"name": "youtubeVideoIds",
				"type": "bytes32[16]"
			},
			{
				"name": "coverArtHashes",
				"type": "bytes32[16]"
			},
			{
				"name": "discogIds",
				"type": "uint256[16]"
			},
			{
				"name": "tagsToAdd",
				"type": "bytes32[4][16]"
			},
			{
				"name": "stylesToAdd",
				"type": "bytes32[4][16]"
			},
			{
				"name": "countries",
				"type": "bytes32[16]"
			},
			{
				"name": "sampleYears",
				"type": "int16[16]"
			}
		],
		"name": "newSampleWithMetadata",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHashes",
				"type": "bytes32[16]"
			}
		],
		"name": "test2",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"name": "c",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "discogsId",
				"type": "uint256"
			},
			{
				"indexed": true,
				"name": "coverArtHash",
				"type": "bytes32"
			}
		],
		"name": "NewDiscogsSample",
		"type": "event"
	}
        ];
            
        this.contractAddress = '0x18d2c1f1f70ecbeb6366c65cef684e229ff6d6b9';
    }


    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default MultiSamplesContract;
